module.exports = __webpack_public_path__ + "img/pazarplus-ind-card.13018f1d.jpg";